import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PageHeader } from 'src/app/models/common/page-header';
import { AgentService } from '../services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { FieldItem } from 'src/app/models/common/field-item';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { BaseComponent } from 'src/app/system-common/base/base.component';

@Component({
  selector: '',
  template: '',
})
export class AgentHierarchyBranchHandler extends BaseComponent<AgentService> implements OnChanges {
  @Input() public service: any;
  @Input() public model: any;
  public searchName: string;
  public isbranchIdSearchDisplayed: boolean;
  public branchIdSelectedOption: any;
  public isDisable: boolean;
  protected branchIdFieldItems: FieldItem[];

  constructor(public agentService: AgentService, public router: Router, public settingService: SettingService) {
    super(agentService);
  }

  ngOnInit() {
    super.ngOnInit();
    if (
      this.service.responseIO.data.Entity.applicationStatusCd == 'SUBMITTED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'ONHOLD' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'REJECTED'
    ) {
      this.isDisable = true;
    } else this.isDisable = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes['model'] && changes['model'].currentValue) {
      this.model = changes['model'].currentValue;
    }
  }

  protected getMoreOptionList(): any[] {
    return [];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Search - Branch';
    return header;
  }

  public onbranchIdSearchClick(field: FieldItem) {
    this.branchIdSelectedOption = undefined;
    this.isbranchIdSearchDisplayed = true;
    setTimeout(() => {
      let id = this.model == undefined ? field.model.guid : this.model.guid;
      this.openModal('branchIdSearch' + id);
    }, 50);
  }

  public onbranchIdSearchSelected(selectedOption) {
    this.branchIdSelectedOption = selectedOption;
    // this.service.setModelFieldValue(this.model, 'branchId', selectedOption['branchId']);
    // this.service.setModelFieldValue(this.model, 'branchName1', selectedOption['branchName1']);
    this.service.setModelFieldValue(this.model, 'agentName', selectedOption['agentName']);
    this.service.setModelFieldValue(this.model, 'branchId', selectedOption['agentId']);
  }

  public onbranchIdFieldsCreated(fieldItemArray: FieldItem[]) {
    if (this.branchIdFieldItems != undefined) {
      fieldItemArray.filter((item) => {
        let index = this.branchIdFieldItems.findIndex((field: FieldItem) => field.fieldCd == item.fieldCd);
        let isAvailable = this.branchIdFieldItems.find((field: FieldItem) => field.fieldCd == item.fieldCd);
        if (!isAvailable) this.branchIdFieldItems.push(item);
        if (isAvailable) this.branchIdFieldItems[index] = item;
      });
    } else {
      // console.log('fieldItemArray', fieldItemArray);
      this.branchIdFieldItems = fieldItemArray;
    }
  }

  ngOnDestroy() {
    this.isbranchIdSearchDisplayed = false;
  }
}
